import { render, staticRenderFns } from "./FormBrands.vue?vue&type=template&id=4e45dd82&scoped=true"
import script from "./FormBrands.vue?vue&type=script&lang=js"
export * from "./FormBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45dd82",
  null
  
)

export default component.exports